import { render, staticRenderFns } from "./InformationProfile.vue?vue&type=template&id=b90f98cc&"
import script from "./InformationProfile.vue?vue&type=script&lang=js&"
export * from "./InformationProfile.vue?vue&type=script&lang=js&"
import style0 from "./InformationProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports